import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import SEOHead from '../components/common/SEOHead';

export default function LegalNotice() {
  const { t } = useTranslation('legal');
  return (
    <div className="pub-page min-h-screen py-12 px-4">
      <SEOHead
        title="Mentions légales"
        description="Mentions légales de Splinity, application de gestion de budget pour couples et colocations."
        path="/mentions-legales"
      />
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center text-primary-600 hover:text-primary-700 mb-8">
          <ArrowLeft className="w-4 h-4 mr-2" />
          {t('backToHome')}
        </Link>

        <div className="pub-card p-8">
          <h1 className="pub-title text-3xl font-bold mb-8">{t('legalNotice.title')}</h1>

          <div className="pub-notice pub-notice--warn rounded-lg p-4 mb-6">
            <p className="pub-state--warn text-sm">{t('legalNotice.betaNotice')}</p>
          </div>

          <div className="pub-prose max-w-none">
            <h2>{t('legalNotice.editor.title')}</h2>
            <p>{t('legalNotice.editor.content')}</p>
            <p><strong>{t('legalNotice.editor.company')}</strong></p>
            <p>{t('legalNotice.editor.registration')}</p>
            <p>{t('legalNotice.editor.vat')}</p>
            <p>{t('legalNotice.editor.contact')}</p>

            <h2>{t('legalNotice.director.title')}</h2>
            <p>{t('legalNotice.director.content')}</p>

            <h2>{t('legalNotice.host.title')}</h2>
            <p>
              {t('legalNotice.host.content')}<br />
              <strong>{t('legalNotice.host.name')}</strong><br />
              {t('legalNotice.host.address').split('\n').map((line, i) => (
                <span key={i}>{line}<br /></span>
              ))}
              {t('legalNotice.host.phone')}
            </p>

            <h2>{t('legalNotice.intellectualProperty.title')}</h2>
            <p>{t('legalNotice.intellectualProperty.content1')}</p>
            <p>{t('legalNotice.intellectualProperty.content2')}</p>

            <h2>{t('legalNotice.personalData.title')}</h2>
            <p>
              {t('legalNotice.personalData.content')}{' '}
              <Link to="/politique-confidentialite" className="text-primary-600 hover:underline">
                {t('legalNotice.personalData.privacyPolicyLink')}
              </Link>.
            </p>

            <h2>{t('legalNotice.cookies.title')}</h2>
            <p>
              {t('legalNotice.cookies.content')}{' '}
              <Link to="/politique-confidentialite" className="text-primary-600 hover:underline">
                {t('legalNotice.cookies.privacyPolicyLink')}
              </Link>.
            </p>

            <h2>{t('legalNotice.liability.title')}</h2>
            <p>{t('legalNotice.liability.content')}</p>

            <h2>{t('legalNotice.applicableLaw.title')}</h2>
            <p>{t('legalNotice.applicableLaw.content')}</p>

            <p className="pub-subtle text-sm mt-8">
              {t('lastUpdated')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
